/**
 * build new URL when switching languages.
 * preserve current subpath (e.g. /history)
 * Assumes route shape: /{lang}/*
 */
export function buildPathForLang(
  nextLang: string,
  pathname: string,
): string {
  const segments = pathname.split('/').filter(Boolean);

  // if  URL is "/" or something unexpected, fall back to "/{lang}/"
  if (segments.length === 0) {
    return `/${nextLang}/`;
  }

  // rebuild path
  segments[0] = nextLang;
  let newPath = '/' + segments.join('/');

  if (segments.length === 1 && !newPath.endsWith('/')) { // ensure trailing slash after language
    newPath += '/';
  }

  return newPath;
}